module.exports = __webpack_public_path__ + "static/img/thumbs-up-solid.5a574d0f.svg";